"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
exports.default = (function (transparent48) { return function (data) {
    var virtual = transparent48.virtual;
    var fields = virtual.protocol.fields;
    var cmds = virtual.protocol.cmds;
    var cmdId = data.cmdId === undefined ? utils_1.find(Object.keys(cmds), function (key) { return cmds[key].cmdTag === data.cmdTag; }) : data.cmdId;
    var cmd = cmdId === undefined ? undefined : cmds[cmdId];
    if (!cmd) {
        return [];
    }
    var msgId = utils_1.decToHex(virtual.msgId % 0xffff, 2);
    var frame = [
        0x48,
        8,
        9,
        0,
        utils_1.hexToDec(msgId.slice(0, 2)),
        utils_1.hexToDec(msgId.slice(2, 4)),
        cmd.cmdId
    ].map(function (val) { return utils_1.decToHex(val); });
    cmd.fields.forEach(function (field) {
        var _a = fields[field], dataLength = _a.dataLength, dataType = _a.dataType;
        frame[1] = utils_1.decToHex(utils_1.hexToDec(frame[1]) + dataLength);
        if (dataType === 'NUMBER') {
            var dec = typeof data[field] === 'number'
                ? utils_1.getCorrectVal(data[field], fields[field])
                : utils_1.getValFromProtocol(fields[field]);
            frame.push.apply(frame, utils_1.splitByLength(utils_1.decToHex(dec, dataLength)));
        }
        else if (dataType === 'STRING') {
            var value = data[field] !== null && data[field] !== undefined ? data[field] : '';
            var hex = utils_1.rawToUTF8Bytes(value).map(function (val) { return utils_1.decToHex(val); });
            var raw = hex.concat(utils_1.creatArrayAndFill(dataLength - hex.length, '00')).slice(-dataLength);
            frame.push.apply(frame, raw);
        }
    });
    return frame;
}; });



// WEBPACK FOOTER //
// ./src/transparent48/encode/9.ts